import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box, Flex, Button } from 'rebass';
import { Banner, NavGrid, Container, Grid, LogoGrid } from '..';
import Logo from '../components/logo';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Banner mdxType="Banner">
      <Box mt={5} mdxType="Box" />
      <LogoGrid mdxType="LogoGrid">
        <Logo text='' size={192} mdxType="Logo" />
        <div>
          <h1 {...{
            "id": "rebass-br--react-primitive-ui-componentsbr-built-with-styled-system"
          }}>{`Rebass `}<br />{` React primitive UI components`}<br />{`built with Styled System`}</h1>
          <pre><code parentName="pre" {...{
              "className": "language-sh"
            }}>{`npm i rebass
`}</code></pre>
        </div>
      </LogoGrid>
      <Box my='auto' mdxType="Box" />
      <NavGrid mdxType="NavGrid">
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/getting-started"
            }}>{`Getting Started`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/props"
            }}>{`Props`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/theming"
            }}>{`Theming`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/variants"
            }}>{`Variants`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/extending"
            }}>{`Extending`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/box"
            }}>{`Box`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/flex"
            }}>{`Flex`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/text"
            }}>{`Text`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/heading"
            }}>{`Heading`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/button"
            }}>{`Button`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/link"
            }}>{`Link`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/image"
            }}>{`Image`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/card"
            }}>{`Card`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/forms"
            }}>{`Forms`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides"
            }}>{`Guides`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes"
            }}>{`Recipes`}</a></li>
        </ul>
      </NavGrid>
    </Banner>
    <Container py={5} mdxType="Container">
      <p><a parentName="p" {...{
          "href": "https://github.com/rebassjs/rebass"
        }}><img parentName="a" {...{
            "src": "https://flat.badgen.net/github/stars/rebassjs/rebass?color=33e",
            "alt": "stars"
          }}></img></a>{`
`}<a parentName="p" {...{
          "href": "https://travis-ci.org/rebassjs/rebass"
        }}><img parentName="a" {...{
            "src": "https://flat.badgen.net/travis/rebassjs/rebass/master?color=33e",
            "alt": "build status"
          }}></img></a>{`
`}<a parentName="p" {...{
          "href": "https://npmjs.com/package/rebass"
        }}><img parentName="a" {...{
            "src": "https://flat.badgen.net/npm/dm/rebass?color=33e",
            "alt": "downloads"
          }}></img></a>{`
`}<a parentName="p" {...{
          "href": "https://codecov.io/github/rebassjs/rebass"
        }}><img parentName="a" {...{
            "src": "https://flat.badgen.net/codecov/c/github/rebassjs/rebass?color=33e",
            "alt": "coverage"
          }}></img></a></p>
      <Grid py={5} sx={{
        fontWeight: 'bold'
      }} mdxType="Grid">
        <ul>
          <li parentName="ul">{`Start your design system without boiling the ocean`}</li>
          <li parentName="ul">{`Build consistent UI with design constraints and user-defined scales`}</li>
          <li parentName="ul">{`Best-in-class developer ergonomics with `}<a parentName="li" {...{
              "href": "https://styled-system.com"
            }}>{`Styled System`}</a>{` props`}</li>
          <li parentName="ul">{`First-class support for theming &
fully compatible with `}<a parentName="li" {...{
              "href": "https://theme-ui.com"
            }}>{`Theme UI`}</a></li>
          <li parentName="ul">{`Quick, mobile-first responsive styles with array-based syntax`}</li>
          <li parentName="ul">{`Flexbox layout with the Box and Flex components`}</li>
          <li parentName="ul">{`Flexibility built in for high design & development velocity`}</li>
          <li parentName="ul">{`Minimal footprint`}</li>
        </ul>
      </Grid>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "live=true",
          "live": "true"
        }}>{`<Flex
  alignItems='center'
  px={3}
  py={4}
  bg='muted'>
  <Heading>Hello</Heading>
  <Box mx='auto' />
  <Button>Beep</Button>
  <Button ml={2} variant='secondary'>Boop</Button>
</Flex>
`}</code></pre>
      <Grid width={448} py={5} mdxType="Grid">
        <ul>
          <li parentName="ul">
            <blockquote parentName="li">
              <p parentName="blockquote">{`“One of the best React component libs out there”`}</p>
            </blockquote>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://twitter.com/mxstbr/status/882657561111080960"
                }}>{`Max Stoiber`}</a></li>
            </ul>
          </li>
          <li parentName="ul">
            <blockquote parentName="li">
              <p parentName="blockquote">{`“Rebass is the Bootstrap of React.”`}</p>
            </blockquote>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://twitter.com/jorilallo/status/882990343225868289"
                }}>{`Jori Lallo`}</a></li>
            </ul>
          </li>
          <li parentName="ul">
            <blockquote parentName="li">
              <p parentName="blockquote">{`“A whopper component library built on styled-components. Responsive, systematic, scalable...the business!”`}</p>
            </blockquote>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://twitter.com/colmtuite/status/882715087936606210"
                }}>{`Colm Tuite`}</a></li>
            </ul>
          </li>
          <li parentName="ul">
            <blockquote parentName="li">
              <p parentName="blockquote">{`“Why the hell are we now putting CSS in Javascript? I’m losing my mind with web developers trying to control everything in the world with client-side javascript. What a mess.”`}</p>
            </blockquote>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "https://news.ycombinator.com/item?id=14705579"
                }}>{`alttab`}</a></li>
            </ul>
          </li>
        </ul>
      </Grid>
      <h2 {...{
        "id": "get-started"
      }}>{`Get Started`}</h2>
      <Button as='a' variant='big' href='/getting-started' mdxType="Button">
  Read the docs
      </Button>
    </Container>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      